import React from "react";

export const ArrowIcon = () => (
	<svg width="16" height="17" viewBox="0 0 16 17" fill="none">
		<path
			d="M12.6667 8.5H3.33333M3.33333 8.5L8 13.1667M3.33333 8.5L8 3.83334"
			stroke="#4BA540"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
